import styled from '@emotion/styled';
import { Button, Flex, Icon as CommonIcon, Stack } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { motion } from 'framer-motion';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

/*
 * bottomOffset: 기본 16px + 하단 썸네일 스트립(148px) 열림 시 그만큼 상승.
 * env(safe-area-inset-bottom)로 iOS Safari 주소창/홈 인디케이터 영역을 피한다.
 */

/* V1 MobilePageNavigationButton과 동일한 하단 중앙 반투명 블러 필 */
export const NavPill = styled(Flex)<{ bottomOffset: number }>`
  position: fixed;
  z-index: ${VIEWER_Z_INDEX.mobileLayer};
  bottom: calc(
    ${({ bottomOffset }) => bottomOffset}px + env(safe-area-inset-bottom, 0px)
  );
  left: 50%;
  width: auto;
  height: auto;
  border: 1px solid ${theme.colors.zinc_500};
  backdrop-filter: blur(8px);
  background-color: rgb(255 255 255 / 50%);
  border-radius: 9999px;
  transform: translate(-50%, 0);
  transition: opacity 0.15s ease-in-out, bottom 0.15s ease-in-out;

  &.disabled {
    cursor: initial;
    opacity: 0;
  }
`;

/* V1 MobilePageMoveButton과 동일한 투명 화살표 버튼 */
export const NavArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: opacity 0.15s ease-in-out;

  &:disabled {
    cursor: initial;
    opacity: 0.25;
  }
`;

/* V1 MobilePageIndicator와 동일한 높이의 인디케이터 영역 */
export const IndicatorWrapper = styled(Stack)`
  width: auto;
  height: 43px;
  flex: 0 0 0px;
  background-color: transparent;
`;

export const CurrentPageBox = styled(Flex)`
  width: auto;
  min-width: 32px;
  height: 23px;
  padding: 4px;
  background: ${theme.colors.zinc_100};
  border-radius: 4px;
  color: ${theme.colors.black};
`;

/*
 * V1 MobileViewerLayer(PositionWrapper)와 동일한 접이식 드로어.
 * 세로: 우하단에서 위로 확장 / 가로(landscape): 우상단에서 옆으로 확장.
 */
export const DrawerWrapper = styled(Stack)<{
  isMobileLandscape: boolean;
  bottomOffset: number;
}>`
  position: fixed;
  z-index: ${VIEWER_Z_INDEX.mobileLayer};
  right: 16px;
  width: auto;
  height: auto;
  background-color: transparent;
  transition: opacity 0.15s ease-in-out, bottom 0.15s ease-in-out;

  ${({ isMobileLandscape, bottomOffset }) =>
    isMobileLandscape
      ? `top: 16px;`
      : `bottom: calc(${bottomOffset}px + env(safe-area-inset-bottom, 0px));`}

  &.disabled {
    cursor: initial;
    opacity: 0;
  }
`;

export const DrawerToggleButton = styled(Button)`
  z-index: ${VIEWER_Z_INDEX.mobileLayer};
  width: 43px;
  height: 43px;
  padding: 8px;
  border: 1px solid ${theme.colors.zinc_300};
  box-shadow: none;
  transition: opacity 0.15s ease-in-out;

  /* V1 파리티: 가로 모드에서 닫힘 상태일 때 반투명 */
  &.backgroundOpacity {
    opacity: 0.5;
  }
`;

export const MotionDrawer = styled(motion.div)<{ isFlexRow: boolean }>`
  display: flex;
  flex-direction: ${({ isFlexRow }) => (isFlexRow ? 'row' : 'column')};
  gap: 8px;
`;

/* V1 MobileZoomButton과 동일한 줌 컨트롤(세로: 위아래 / 가로: 좌우) */
export const ZoomPillButton = styled(Button)`
  z-index: ${VIEWER_Z_INDEX.mobileLayer};
  width: 43px;
  height: auto;
  padding: 8px;
  box-shadow: none;
  transition: opacity 0.15s ease-in-out;

  &.isLandscape {
    width: auto;
    height: 43px;
  }
`;

export const ZoomIcon = styled(CommonIcon)`
  margin: 4px;
`;

/* V1 MobileButton과 동일한 43px 원형 아이콘 버튼(전체화면/V1 전환용) */
export const RoundIconButton = styled(Button)`
  z-index: ${VIEWER_Z_INDEX.desktopLayer};
  width: 43px;
  height: 43px;
  padding: 8px;
  box-shadow: none;
  transition: opacity 0.15s ease-in-out;
`;
